import React, { useEffect, useState } from 'react';
import { Waypoint } from 'react-waypoint';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Collapse } from 'reactstrap';
import MinusIcon from 'mdi-react/MinusIcon';
import PlusIcon from 'mdi-react/PlusIcon';
import { scroller } from 'react-scroll';
import FeatureItem from './FeatureItem';
import { changeFeature, setUnfoldedCategory, updateFocusedCategory } from '../../../model/configuratorSlice';
import useWindowSize from '../../../hooks/useWindowSize';
import FeatureItemMobile from './FeatureItemMobile';
import { MobileWidth } from '../../../model/constants';
import { TranslationUtility } from '../../../utilities/TranslationUtility';

const CategoryItem = ({
  category, roomId, isLastItem,
  order, disabled,
}) => {
  const windowsSize = useWindowSize();
  const [isOpen, setIsOpen] = useState(false);
  const currentUnfoldedCategory = useSelector(state => state.configurator.currentUnfoldedCategory);
  const currentUnfoldOffset = useSelector(state => state.configurator.currentUnfoldOffset);
  const dispatch = useDispatch();

  useEffect(() => {
    setIsOpen(currentUnfoldedCategory === (`${roomId.toString() }-${category.id.toString()}`));
  }, [currentUnfoldedCategory]);

  const onCategoryTouched = () => {
    if (isOpen) {
      dispatch(setUnfoldedCategory(''));
    } else {
      const offset = (order + 1) * 37 + (order < 5 ? 2 : -2);
      dispatch(setUnfoldedCategory({ id: `${roomId.toString() }-${category.id.toString()}`, offset }));
      dispatch(updateFocusedCategory({ room: roomId, category: category.id }));
    }
  };

  const unfoldComplete = () => {
    scroller.scrollTo(roomId,
      {
        containerId: 'container-rooms',
        offset: currentUnfoldOffset,
        duration: 600,
        delay: 0,
        smooth: 'easeInOut',
      });
  };

  const onFeatureSelected = (selectedFeatureId) => {
    dispatch(changeFeature({
      room: roomId,
      feature: selectedFeatureId,
      category: category.id,
    }));
  };

  if (disabled) return null;

  return (
    <div className="category-item">
      <Waypoint topOffset={200} />
      <button type="button" onClick={onCategoryTouched} className="category-title-button">
        <span>{TranslationUtility.GetFormattedMessageForCategoryName(category)}</span>
        <PlusIcon className={`icon ${!isOpen ? '' : ' hidden'}`} />
        <MinusIcon className={`icon ${isOpen ? '' : ' hidden'}`} />
      </button>

      <div className="divider" />
      <Collapse isOpen={isOpen} onEntered={() => unfoldComplete()}>
        <div className="container-features">
          {category.features.map((feature, index) => (
            windowsSize.width < windowsSize.height && windowsSize.width < MobileWidth ? (
              <FeatureItemMobile
                feature={feature}
                categoryId={category.id}
                isSelected={category.selected_feature === feature.id}
                onFeatureSelected={onFeatureSelected}
                disabled={feature.disabled}
              />
          ) : (
            <FeatureItem
              feature={feature}
              categoryId={category.id}
              isSelected={category.selected_feature === feature.id}
              onFeatureSelected={onFeatureSelected}
              disabled={feature.disabled}
            />
          )))}
        </div>
      </Collapse>
      {isLastItem
        ? (<Waypoint topOffset={30} />)
        : (<Waypoint topOffset={200} />)}


    </div>
  );
};

CategoryItem.propTypes = {
  category: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
    cameras: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      roomId: PropTypes.string,
      isPriority: PropTypes.bool,
    })),
    selected_feature: PropTypes.string,
    features: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
      description: PropTypes.string,
      thumb: PropTypes.string,
      price: PropTypes.string,
      order: PropTypes.number,
      disabled: PropTypes.bool,
    })),
  }).isRequired,
  roomId: PropTypes.string.isRequired,
  isLastItem: PropTypes.bool.isRequired,
  order: PropTypes.number.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default CategoryItem;
